module.exports = __webpack_public_path__ + "static/media/list-car.08e5dd73.png";